// extracted by mini-css-extract-plugin
export default {"IFrame":"styles_IFrame__rqjDq","IframeContainer":"styles_IframeContainer__05MF1"};